import React from 'react';

import UIPlaceholder from 'ui-library/UIPlaceholder';

import {AnalysisMainViewItemType, MainViewComponentProps} from './MainViewTypes';

export default function EmptyAnalysisView({
  analysis,
}: MainViewComponentProps<AnalysisMainViewItemType.EMPTY_ANALYSIS>): JSX.Element {
  return (
    <UIPlaceholder
      infoSection={
        !analysis.permissions.writable
          ? "This analysis doesn't have anything in it."
          : 'Add data to get started.'
      }
    />
  );
}
